import { format } from "date-fns";
import { formatDate } from "../../../utils";
import { value } from "../../../helpers";

export const PERIODO_PRESETS = [
  { label: "Essa Semana", key: "semana" },
  { label: "Esse Mês", key: "mes" },
  { label: "15 dias", key: "quinzeDias" },
  { label: "6 Meses", key: "semestre" },
  { label: "Este Ano", key: "ano" },
];

function inicioSemana(d) {
  const data = new Date(d);
  data.setDate(data.getDate() - data.getDay());
  return data;
}

export function intervaloPreset(preset) {
  const hoje = new Date();
  let de = new Date();
  let ate = new Date();
  switch (preset.key) {
    case "semana":
      de = inicioSemana(hoje);
      break;
    case "mes":
      de = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
      break;
    case "quinzeDias":
      de.setDate(hoje.getDate() - 15);
      break;
    case "semestre":
      de = new Date(hoje.getFullYear(), hoje.getMonth() - 6, hoje.getDate());
      break;
    case "ano":
      de = new Date(hoje.getFullYear(), 0, 1);
      break;
    default:
      de.setDate(hoje.getDate() - 30);
  }
  return { de: formatDate.toSend(de), ate: formatDate.toSend(ate) };
}

export const filtrosIniciais = {
  ...intervaloPreset({ key: "mes" }),
  empresas: [],
  contas: [],
  centroCusto: null,
};

export function buildFiltrosBody(filtros) {
  return {
    filtros: {
      porIntervalo: [{ de: filtros.de, ate: filtros.ate, coluna: "data" }],
      empresasIds: filtros.empresas?.length
        ? filtros.empresas.map((e) => e.id)
        : undefined,
      contasIds: filtros.contas?.length
        ? filtros.contas.map((c) => c.id)
        : undefined,
      centroCustoId: filtros.centroCusto?.id || undefined,
    },
  };
}

export function formatarDataChip(dataStr) {
  if (!dataStr) return "";
  return format(value.date(dataStr), "dd/MM/yyyy");
}
